export enum MarketingCampaigns {
    Cashback = 'FY22 INT - Cashback Launch',
    MultiEntity = 'FY22Q3 - INT - Multi Entity Launch',
    InteractiveDemo = 'FY22Q4 - WEB - Navattic - Interactive Demo',
}

export enum Events {
    Blog = 'Blog',
    CashbackLandingPage = 'Cashback Landingpage',
    MultiEntityLandingPage = 'Multi Entity Landingpage',
}

export enum LifecycleStages {
    MQL = 'marketingqualifiedlead',
    Lead = 'lead',
    Subscriber = 'subscriber',
}

export enum ConversionDescriptions {
    EBookLandingPage = 'eBook Landing Page Forms',
    PartnersBigForm = 'bigform-partner',
    Newsletter = 'newsletter',
    DirectMeetingBooked = 'direct-meeting_booked',
    SignupFlow = 'signup_flow',
}

export enum LatestLeadSourceCaptureType {
    BlogPleoDigest = 'Blog - Pleo Digest',
    FreeDemo = 'Free Demo',
    SelfOnboarding = 'Self - Onboarding.  Sign up',
    PartnerBigForm = 'bigform-partner',
    Ebooks = 'Ebooks',
}

export enum Integrations {
    Travelperk = 'TravelPerk',
    Bolt = 'Bolt',
    Sesame = 'Sesame',
}

export enum LeadType {
    Partners = 'Partner lead',
}

export enum HubspotPartnerChannel {
    TechnologyPartners = 'Technology partners',
    AccountingPartner = 'Accounting partners',
    AffiliatePartner = 'Affiliate',
    ConsultingPartner = 'Consulting partners',
    OtherReseller = 'Other Resellers',
}

export enum HubspotTypeOfInfluence {
    PartnerSource = 'Partner-sourced',
}

export enum HubspotPartnerSegment {
    Referral = 'Referral',
}

export enum HubspotPartnershipType {
    Distribution = 'Distribution',
}
